Revolution.Module.extend({
    NAME: "mde.bk-conditionnal-popin", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/view-password.js)

    defaults: {
        'cookieExpires' : undefined, // duree de session en j
        'delayPopin' : 800
    },
    initialize: function ($) {
        $popin = $('.bk-conditional-popin');
        if ($popin.length) {
            var _this = this;
            var dataExpires = parseInt($popin.data('cookie-expires'));
            _this.defaults.cookieExpires = (dataExpires != '') ? dataExpires : undefined;
            _this.defaults.delayPopin = parseInt($popin.data('delay-popin'));
            $popin.find('.bk-conditional-popin__picto img').removeAttr('loading');
            _this.displayConditionnalPopin();

            $('body').on('click', '.js-mfp-close', function (e) {
                if ($(e.currentTarget).closest('.popin').length) {
                    $.magnificPopup.close();
                } else {
                    Cookies.set('conditionalPopin', "closed", {  expires: _this.defaults.cookieExpires, path: '/' });
                    $('.bk-conditional-popin').slideUp();
                }
            });

            $('body').on('click', '.js-no-more-display', function (e) {
                e.preventDefault();
                var lk = $(e.currentTarget).attr('href');Cookies.set('conditionalPopin', "closed", {  expires: _this.defaults.cookieExpires, path: '/' });
                window.location = lk;
            });
        }
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },

    onWindowResize: function (e) {

    },

    displayConditionnalPopin: function () {
        var _this = this;
        if (Cookies.get('conditionalPopin') == null) { // si le cookie n'existe pas -> affichage de la popin
            setTimeout(function () {
                $.magnificPopup.open({
                    items: {
                        src: '#block-popinconditionelle',
                        type: 'inline'
                    },
                    callbacks: {
                        afterClose: function() {
                            _this.setSmartBanner();
                            Cookies.set('conditionalPopin', "smartbanner", { expires: _this.defaults.cookieExpires, path: '/' });
                        }
                    }
                });
                $(window).trigger('resize'); // lazy refresh
            }, this.defaults.delayPopin);

        } else if (Cookies.get('conditionalPopin') == 'smartbanner') { // Si le cookie = smartbanner -> smartbanner, si cookie = closed --> on affiche rien
            this.setSmartBanner();
        }
    },
    setSmartBanner: function () {
        $popin = $('.bk-conditional-popin');
        $popin.removeClass('popin').removeClass('mfp-hide').addClass('banner');
        $('.page-header-wrapper').prepend($popin);
    }
});
